// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import axios from 'axios';
import VueWechatTitle from 'vue-wechat-title';
import store from './store/index'
import 'vant/lib/index.css';
import 'lib-flexible/flexible.js';
//引入组件
import components from '@/assets/js/components.js';

// 引入方法
import commonM from '@/assets/js/Commonmethods.js'
let img = {
  install(Vue) {
    Vue.prototype.img = {
      ResizeParam: (obj, fineTune, file) => {
        let str = file ? file : 'jpg'
        let ft = (fineTune && Number.isFinite(fineTune) ? fineTune : 0);
        let width = ',w_' + (obj.w + ft);
        let height = ',h_' + (obj.h + ft);
        return '?x-oss-process=image/resize' + width + height + '/format,' + str;
      }
    };
    //html 里图片压缩
    Vue.prototype.imgFormat = (content) => {
      if (content == undefined) {
        return false;
      }
      content = content.replace(/<img.*?src=[\"|\']?(.*?)[\"|\']?\s.*?>/g, (e) => {
        //解决引入图片403  防盗链问题  方法一：  目前采用使用<meta name="referrer" content="no-referrer" />
        e = e.replace(/<img[^>]+src=['"]([^'"]+)['"]+/g, (match, capture) => {
          return match.replace(/src=['"]([^'"]+)['"]/, `src="${capture}?x-oss-process=image/resize,w_551,h_361/format,png"`)
          //          return match.replace(/src=['"]([^'"]+)['"]/, `src=" src "`)
        });
        if (e.match(/width="/)) {
          return e;
        }
        // 解决引入图片403防盗链问题  方法二
        return e.replace(/\/>/, 'referrer="no-referrer|origin|unsafe-url" width="100%" />');
      })
      return content;
    }
    //图片处理
    Vue.prototype.resizeParam = (obj, fineTune, file) => {
      let str = file ? file : 'jpg'
      let ft = (fineTune && Number.isFinite(fineTune) ? fineTune : 0);
      let width = obj.w && obj.w > 0 ? ',w_' + (obj.w + ft) : "";
      let height = obj.h && obj.h > 0 ? ',h_' + (obj.h + ft) : "";
      return '?x-oss-process=image/resize' + width + height + '/format,' + str;
    };

  }
}

//埋点配置
let $this = this;
// 判断是否是会员;
// this.commonM.requestIsMember();
// 微信授权;
let evox = new Evox({
  axios,
  appId: "wx14d37d47cdf1b908",
  isMandatoryWxAuth: true
});
Vue.prototype.evox = evox;
evox.wxLogin().then(res => {
  console.log("用户信息：", res);
  localStorage.setItem("res", res);
  localStorage.setItem("openid", res.channelUid);
  localStorage.setItem("userid", res.id);
  // this.main_switch = true
  // requestIsMember.requestIsMember($this)
  Vue.prototype.userInfo = res
  var cm = new Customized({
    axios, //customized.js 调用后台接口基于 axios 库，请在初始化之前引入axios并作为初始参数初始化customized对象
    router, //customized.js 中埋点字段中的viewTitle是获取的router中的meta的routerTitle属性
    vm: Vue, //customized.js 把每一个行为的埋点添加在自定义指令中，需要在实例化的时候引入Vue实例
    channelId: res.channelId, //用户的channelId
    insId: res.insId, //用户所属机构的insId
    contactId: res.id //用户的id
  });
  Vue.prototype.cm = cm;
  Vue.prototype.emit = cm.emit;

  Vue.use(img)
  // 写的方法
  Vue.prototype.commonM = commonM;
  //用户信息
  Vue.prototype.user = {
    name: '小花花',
    userId: 62
  }
  // 判断是否是会员
  Vue.prototype.isMember = false;
  //一键播号
  Vue.prototype.phone_num = '400 120 0052'
  //siemens 站点内容结构ID
  Vue.prototype.channelId = 40;
  //是否已经登陆
  Vue.prototype._is_login = true
  // 上传图片动画
  Vue.prototype.upload_img = false

  // axios.defaults.withCredentials = true

  Vue.prototype.$href = 'https://www.commnowmatrix.com/Siemens/#';

  Vue.use(components);
  Vue.prototype.$axios = axios;
  Vue.use(Vant);
  Vue.use(VueWechatTitle);

  Vue.config.productionTip = false

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    components: {
      App
    },
    template: '<App/>'
  })
});



// WEBPACK FOOTER //
// ./src/main.js